export interface IDTOUsuarioPrivilegio {
    identificador: string;
    descricao: string;
    valor: boolean;
}

const listaPadraoPrivilegiosUsuario: IDTOUsuarioPrivilegio[] = [
  { identificador: 'CONFIGURACOES', descricao: 'Configurações', valor: false },
  { identificador: 'USUARIOS', descricao: 'Usuários', valor: false },
  { identificador: 'INSPECOES', descricao: 'Inspeções', valor: false },
  { identificador: 'CADASTROS', descricao: 'Segurados', valor: false },
];

export default listaPadraoPrivilegiosUsuario;
